import { render, staticRenderFns } from "./SparringPage.vue?vue&type=template&id=4ef451a4&scoped=true"
import script from "./SparringPage.vue?vue&type=script&lang=js"
export * from "./SparringPage.vue?vue&type=script&lang=js"
import style0 from "./SparringPage.vue?vue&type=style&index=0&id=4ef451a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef451a4",
  null
  
)

export default component.exports